import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import ScenarioBar from "../components/ScenarioBar";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import oncommit from "../assets/onconext.png";
import avatarVideo from "../assets/avatares/mute-red.webm";
import avatarVideoMp4 from "../assets/avatares/mute-red.mp4";
import avatarDummy from "../assets/avatares/avatar-dummy.png";

import { useVideoWithSound } from "../hooks/useVideoWithSound";

function GameIntroduction({ intl }) {
  const lang = useLang();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const group = useSelector((state) => state.group);
  const [isCompleted, setIsCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const { completed } = state || false;
  
  const { videoRef, canPlayWithSound } = useVideoWithSound({ 
	autoPlay: true, 
	volume: 0.8
  });

  const activeScenario = 0;

  const handleStartGame = (e, direction = "next") => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    getGameById(game?._id).then((res) => {
      if (res.status === 200) {
        updateStats({
          ...group,
          actualScenario: 1,
          time: 0,
          lastVisited: ROUTES.START_GAME,
        });

        const goBack = direction === "back";
        navigate(goBack ? ROUTES.START_GAME : ROUTES.START_GAME3, {
          state: { activeScenario: goBack ? 0 : 1 },
        });
      } else {
      	setLoading(false);
	  }
    });
  };

  return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							className="mt-5"
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "100%",
							}}
						/>
						<h1 className="txtTitulos txt-red bold">
						Reglas del Patient Room I
						</h1>
						<video
							ref={videoRef}
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end h-100 px-4 bg-blur">
						<div className="recuadro-white mb-2 w-100">
							<h3 className="txtTexto1 txt-red bold">
								Trabajo en equipo
							</h3>
							<p className="txtTexto1 black">
								Formarán parte de un equipo que deberá superar distintos retos y pruebas clínicas de forma colaborativa.
							</p>
						</div>
						<div className="recuadro-white mb-2 w-100">
							<h3 className="txtTexto1 txt-red bold">
								Toma de decisiones acertadas
							</h3>
							<p className="txtTexto1 black">
								Para avanzar, el equipo deberá dar respuestas correctas en las decisiones clínicas.
							</p>
						</div>
						<div className="recuadro-white mb-2 w-100">
							<h3 className="txtTexto1 txt-red bold">
								Avance por etapas
							</h3>
							<p className="txtTexto1 black">
								Cada pantalla presentará un desafío distinto: preguntas de opción múltiple, ejercicios de selección, de arrastre y análisis de resultados.
							</p>
						</div>
						<div className="recuadro-white mb-2 w-100">
							<h3 className="txtTexto1 txt-red bold">
								Control del progreso
							</h3>
							<p className="txtTexto1 black">
								Una barra inferior les mostrará su ubicación dentro del juego y las actividades pendientes de resolver.
							</p>
						</div>
						<div className="d-flex justify-content-end align-items-center">
							<div className="txtBotones me-3">
								Siguiente
							</div>
							<button
								onClick={(e) => handleStartGame(e, "next")}
								className="btn-main btn-progress"
								data-loading={loading ? "true" : "false"}
								style={{ width: 80, height: 80, borderRadius: "50%" }}
								aria-busy={loading}
							>
								<img
								src={flechaAvanzar}
								alt="Siguiente"
								style={{ maxWidth: "40px" }}
								/>
							</button>              
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(GameIntroduction);
